import { createFileRoute } from '@tanstack/react-router';

import { StaffQueueView } from 'src/sections/staff/queue/queue-view';
import {
  QUEUE_SORTS,
  QUEUE_VIEWS,
  type QueueSort,
  type QueueView,
  DEFAULT_QUEUE_SORT,
} from 'src/sections/staff/queue/queue-views';

type QueueSearch = {
  /** Which of the seven views is on screen. In the URL so a view is shareable. */
  view: QueueView;
  /** Narrow to one brand. Set by the brand filter and the "everything for this brand" link. */
  clientId?: string;
  /** Narrow to one engagement. Set by the engagement screens. */
  engagementId?: string;
  /**
   * Row order. In the URL for the same reason the view is: a queue someone sends
   * you should arrive ordered the way they were reading it. Absent means the
   * default, so the common case keeps a clean URL and callers linking to the
   * queue do not have to name an ordering they have no opinion about.
   */
  sort?: QueueSort;
};

export const Route = createFileRoute('/w/queue')({
  validateSearch: (search: Record<string, unknown>): QueueSearch => ({
    view: QUEUE_VIEWS.some((entry) => entry.value === search.view)
      ? (search.view as QueueView)
      : 'all',
    clientId: typeof search.clientId === 'string' ? search.clientId : undefined,
    engagementId: typeof search.engagementId === 'string' ? search.engagementId : undefined,
    sort: QUEUE_SORTS.some((entry) => entry.value === search.sort)
      ? (search.sort as QueueSort)
      : undefined,
  }),
  component: StaffQueuePage,
});

function StaffQueuePage() {
  const { view, clientId, engagementId, sort } = Route.useSearch();
  return (
    <StaffQueueView
      view={view}
      clientId={clientId}
      engagementId={engagementId}
      sort={sort ?? DEFAULT_QUEUE_SORT}
    />
  );
}
